import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('@/components/AppLayout.vue'),
    children: [
      { path: '', name: 'calendar', component: () => import('@/pages/CalendarPage.vue') },
      { path: 'eventos', name: 'events', component: () => import('@/pages/EventsPage.vue') },
      { path: 'disponibilidad', name: 'availability', component: () => import('@/pages/AvailabilityPage.vue') },
      { path: 'economia', name: 'economy', component: () => import('@/pages/EconomyPage.vue'), meta: { staff: true } },
      { path: 'integrantes', name: 'members', component: () => import('@/pages/MembersPage.vue'), meta: { admin: true } },
      { path: 'administracion', name: 'admin', component: () => import('@/pages/AdminPage.vue'), meta: { superadmin: true } },
      { path: 'perfil', name: 'profile', component: () => import('@/pages/ProfilePage.vue') },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  // Espera a conocer la sesión antes de decidir (evita una carrera en el primer
  // arranque donde el guard redirige a login antes de cargar /api/me).
  if (!auth.loaded) {
    await auth.fetchCurrentUser()
  }
  if (!to.meta.public && !auth.isAuthenticated) {
    return { name: 'login', query: to.fullPath !== '/' ? { redirect: to.fullPath } : {} }
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'calendar' }
  }
  if (to.meta.staff && !auth.isStaff) {
    return { name: 'calendar' }
  }
  if (to.meta.admin && !auth.isAdmin) {
    return { name: 'calendar' }
  }
  if (to.meta.superadmin && !auth.isSuperadmin) {
    return { name: 'calendar' }
  }
  return true
})

export default router
